import { getClosest, iterateNodes } from './dom';

export default class MoreTextHandler {
  constructor(settings) {
    let settingSelectors = settings.selectors || [];
    let selectors = [].concat(settingSelectors);
    let defaultVal = settings.defaultVal || 0;
    let innerReadMore = settings.innerReadMore || false;

    selectors.forEach(selector => {
      iterateNodes(selector, this.hideText, defaultVal);
      iterateNodes(selector, this.toggleText, defaultVal, innerReadMore);
    });
  }

  hideText(element, defaultVal) {
    let textNode = element.previousSibling;
    textNode.dataset.defaultVal = defaultVal;
    jQuery(textNode).animate({ 'height': defaultVal + 'px' });
  }

  toggleText(element, defaultVal, innerReadMore) {
    element.addEventListener('click', function (e) {
      let textNode = element.previousSibling;
      let textNodeHeight = textNode.clientHeight;
      let outerTextNode = null;
      let scrollHeight = textNode.scrollHeight;

      if (innerReadMore) {
        outerTextNode = getClosest(element, '.text-wrap');
      }

      if (textNodeHeight < scrollHeight) {
        element.children[0].textContent = element.getAttribute('data-text-less');
        element.setAttribute('data-scroll-pos', window.scrollY);
        element.classList.add('-open');

        let height = textNode.scrollHeight;
        jQuery(textNode).animate({ 'height': height + 'px' });

        if (outerTextNode && outerTextNode.clientHeight > 400) {
          height = outerTextNode.scrollHeight + textNode.scrollHeight;
          outerTextNode.style.height = height + 'px';
        }
        return;
      }

      jQuery('html, body').animate({ scrollTop: jQuery(textNode).offset().top - 200 }, 300, 'linear', () => {
        jQuery(textNode).animate({ 'height': defaultVal + 'px' });
        if (outerTextNode && outerTextNode.clientHeight > 400) {
          let height = outerTextNode.scrollHeight - textNode.scrollHeight;
          outerTextNode.style.height = height + 'px';
        }
      });

      element.classList.remove('-open');
      element.children[0].textContent = element.getAttribute('data-text-more');
    });
  }


  static getVisibleHeightFromElement(defaultEl) {
    let elHeight = defaultEl.clientHeight;
    let elStyle = window.getComputedStyle(defaultEl);
    let fontSize = parseInt(elStyle.getPropertyValue('font-size').replace('px', ''));
    return elHeight + fontSize;
  }

}